<template>
  <div>
    <dashboard-index />
  </div>
</template>

<script>
import DashboardIndex from '@/views/Dashboard/Index.vue'

export default {
  components: {
    DashboardIndex,
  },
}
</script>

<style>

</style>
